import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../lib/i18n';
import {
    authLogin,
    setAppUser,
    useAppContext,
} from '../../contexts/AppContext';
import { createLoginPageStyles } from './LoginPageStyles';
import { useNavigate } from 'react-router-dom';
import {
    getDivisionUserList,
    getUser,
    getUserPerms,
    login,
} from '../../services/organizationService';
import packageJson from '../../../package.json';
import { paths } from '../../utils/paths';
import { LoadingProgress } from '../../lib/components/LoadingProgress/LoadingProgress';
import { AppTheme } from '../../theme';
import { useTheme } from '@mui/material';
import { ButtonApp, TextFieldApp } from '../../lib/commonStyles';
import PasswordField from '../components/PasswordField';

interface FormState {
    username: string;
    password: string;
    showPassword: boolean;
}

function LoginPage(props: any) {
    const theme: AppTheme = useTheme();
    const styles = createLoginPageStyles(theme);
    const navigate = useNavigate();
    const { storeUserPerms, setMenuIndex, darkTheme, setDarkTheme } = useAppContext();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [values, setValues] = React.useState<FormState>({
        username: '',
        password: '',
        showPassword: false,
    });
    const [errorPass, setErrorPass] = React.useState<boolean>(false);
    const [t] = useTranslation();

    useEffect(() => {
        console.log('Backoffice version ' + packageJson.version);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeDarkMode = () => {
        setDarkTheme(!darkTheme);
    };

    const handleChange =
        (prop: keyof FormState) => (event: React.ChangeEvent<HTMLInputElement>) => {
            setValues({ ...values, [prop]: event.target.value });
    };

    const onChangePassword = (value:string) => {
        setValues({ ...values, password: value });
    };

    const handleLogin = async () => {
        setIsLoading(true);
        login(values.username, values.password)
            .then(async token => {
                authLogin(token);
                const user = await getUser();
                const divisions = await getDivisionUserList();
                user.divisions = divisions;
                setAppUser(user);
                const perms = await getUserPerms();

                storeUserPerms(perms);
                setMenuIndex(0);
                navigate(paths.home);
            })
            .catch(error => {
                setIsLoading(false);
                setErrorPass(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const changeLang = () => {
        changeLanguage();
        setValues({ ...values });
    };
    return (
        <>
            <Grid container size={{xs:12}} spacing={0} sx={[styles.content]}>
                <Grid size={{md:6}} sx={[styles.leftPanel]}>
                    <Grid size={{md:12}} sx={{width:"100%", mt:"400px", display: "flex", justifyContent:"center"}}>
                        <Box sx={[styles.logoBox]}>
                            <Box component='p' sx={[styles.logo]}></Box>
                        </Box>
                    </Grid>
                    <Grid size={{md:12}} sx={{width:"100%", mt:"20px", overflow: "hidden"}}>
                        <Box component='p' sx={[styles.icon]}></Box>
                    </Grid>
                    
                </Grid>
                <Grid size={{xs:12, sm:12, md:12, lg:6}} sx={{alignContent: "center"}}>
                    <Grid size={{xs:12}} spacing={2} sx={{textAlign: "center", mt: "-135px", height: "500px"}}>
                        <Box sx={{position: "absolute", top: "1vh", right:"2vh"}}>
                            {/*<ButtonApp color="primary" variant="contained" onClick={handleChangeDarkMode}>{darkTheme ? t('LAYOUT.LIGHT_MODE') : t('LAYOUT.DARK_MODE')}</ButtonApp>*/}
                            <ButtonApp color="primary" variant="contained" onClick={changeLang} sx={{ml: "20px"}}>{t('COMMON.CHANGE_LANGUAGE')}</ButtonApp>
                        </Box>
                        <Grid size={{xs:12}} sx={[styles.boxLogo]}>
                            <Box component={"p"} sx={[styles.logoCell, styles.viewOnMobile]}></Box>
                        </Grid>
                        <Grid size={{xs:12}} sx={{mb: "20px", display:{xs: "none", sm: "none", md: "block"}}}>
                            <Typography variant="h1">{t('LOGIN.WELCOME')}</Typography>
                        </Grid>
                        <Grid size={{xs:12}} sx={{width: "100%", mb:"40px"}}>
                            <Typography variant="h3" sx={{display:{xs: "none", sm: "none", md: "block"}}}>{t('LOGIN.LOG_IN')}</Typography>
                        </Grid>
                        <Grid size={{xs:12}} sx={{mb:"30px"}}>
                            <TextFieldApp
                                sx={[styles.textField]}
                                required
                                id="username"
                                label={t('LOGIN.USER')}
                                value={values.username}
                                onChange={handleChange("username")}
                            />
                        </Grid>
                        <Grid size={{xs:12}} sx={{mb:"60px"}}>
                            <PasswordField
                                data-testid="input-password"
                                id="password"
                                label={t('LOGIN.PASSWORD')}
                                onChange={(e:any) => onChangePassword(e)}
                                onKeyUp={(e:any) => (e.key === 'Enter') ? handleLogin() : null}
                                value={values.password}
                                slotProps={{
                                    input: {
                                        sx:{
                                            maxLength: 100,
                                        }
                                    }
                                }}
                                margin="normal"
                                error={errorPass}
                                helperText={errorPass && t('LOGIN.ERROR.PASS_WRONG')}
                                fullWidth
                                required
                                sx={[styles.textField]}
                            />
                        </Grid>

                        <Grid size={{xs:12}} sx={{width: "100%", display: 'flex', justifyContent: "center"}}>
                            <ButtonApp color="primary" variant="contained" onClick={handleLogin} sx={[styles.buttonLogin]} disabled={values.username.trim().length < 1 || values.password.trim().length < 1}>
                                {t('LOGIN.ENTER')}
                            </ButtonApp>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {isLoading && <LoadingProgress />}
        </>
    );
}

export default LoginPage;
